"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var ServiceCounter = function ServiceCounter(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M19.808 13.25h-.287a.4.4 0 01-.372-.249l-1.105-2.78-.41 1.004a.307.307 0 00.038.274 7.238 7.238 0 011.202 3.923.317.317 0 01-.314.328h-1.228l-.299 4.085a.316.316 0 01-.318.29h-.68a.317.317 0 01-.318-.29l-.299-4.085H14.19a.317.317 0 01-.314-.328 7.238 7.238 0 011.202-3.923.307.307 0 00.038-.274l-.41-1.004-1.105 2.78a.399.399 0 01-.372.249h-.287a.314.314 0 01-.312-.38l.198-.87H3.875a.625.625 0 110-1.25h1.253V9.187c0-.862.7-1.562 1.563-1.562h3.118c.863 0 1.563.7 1.563 1.563v1.562h1.74l.376-1.657a1.908 1.908 0 011.87-1.468h2.033a1.908 1.908 0 011.871 1.468l.858 3.777a.314.314 0 01-.312.38zM16.375 7a1.563 1.563 0 110-3.125 1.563 1.563 0 010 3.125zM8.25 7a1.563 1.563 0 110-3.125A1.563 1.563 0 018.25 7z"
  }));
};

var _default = (0, _react.forwardRef)(ServiceCounter);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ServiceCounter, "ServiceCounter", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ServiceCounter.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ServiceCounter.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();